export default __webpack_public_path__ + "static/media/logo4.94d53c6e.png";